import styled from 'styled-components';

export const GridRota = styled.div`
  display: flex;
  align-items: stretch;
  color: rgba(0, 0, 0, 0.45);

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const GridItem = styled.div``;

export const PointRota = styled.span`
  height: 8px;
  width: 8px;
  background-color: #24a95d;
  border-radius: 50%;
  display: inline-block;

  margin: 0 16px 0 0;
`;

export const BarRota = styled.span`
  border-left: 2px solid #24a95d;
  width: 0;
  margin: -5px 19px -5px 3px;
`;

export const NotBarRota = styled.div`
  margin: 0 12px;
`;

export const Text = styled.p`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 4px !important;
`;
